import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../../context/FavoritesContext';
import GameCard from '../../components/GameCard/GameCard';

const fadeIn = keyframes`from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}`;

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  padding: 16px 16px 100px;
  animation: ${fadeIn} 0.3s ease;
`;

const Header = styled.h1`
  font-size: 28px; font-weight: 800; color: #fff; margin: 0 0 20px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

const EmptyWrap = styled.div`
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 80px 20px; text-align: center;
`;
const EmptyIcon = styled.div`font-size: 56px; margin-bottom: 16px; opacity: 0.3;`;
const EmptyTitle = styled.h2`color: rgba(255,255,255,0.6); font-size: 18px; font-weight: 700; margin-bottom: 8px;`;
const EmptyText = styled.p`color: rgba(255,255,255,0.3); font-size: 14px; margin-bottom: 24px;`;
const EmptyBtn = styled.button`
  background: #006FFF; color: #fff; border: none; padding: 12px 28px; border-radius: 14px;
  font-size: 15px; font-weight: 600; cursor: pointer;
  &:active { opacity: 0.8; }
`;

const Favorites = () => {
  const { items } = useFavorites();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <Page>
        <Header>Избранное</Header>
        <EmptyWrap>
          <EmptyIcon>❤️</EmptyIcon>
          <EmptyTitle>Избранное пока пусто</EmptyTitle>
          <EmptyText>Добавляйте игры в избранное, чтобы не потерять их</EmptyText>
          <EmptyBtn onClick={() => navigate('/catalog')}>Перейти в каталог</EmptyBtn>
        </EmptyWrap>
      </Page>
    );
  }

  return (
    <Page>
      <Header>Избранное</Header>
      <Grid>
        {items.map(game => (
          <GameCard key={game.id || game.sony_id} game={game} />
        ))}
      </Grid>
    </Page>
  );
};

export default Favorites;
